import type { FunctionComponent, ReactNode } from "react";

import type { Props as BaseLinkProps } from "~/components/common/base-link";

import { StyledButton, StyledLinkButton, StyledOffsetContainer } from "./styles";

type BaseProps = {
  children: ReactNode;
  className?: string;
  target?: string;
};

type Props =
  | {
      onClick?: () => void;
      variant: "button";
    }
  | ({
      variant: "link";
    } & BaseLinkProps);

export const Button: FunctionComponent<BaseProps & Props> = props => {
  const { children, className, variant } = props;
  return (
    <StyledOffsetContainer backgroundColor="#fecc17">
      {variant === "button" ? (
        <StyledButton className={className} {...props}>
          {children}
        </StyledButton>
      ) : (
        <StyledLinkButton className={className} {...props}>
          {children}
        </StyledLinkButton>
      )}
    </StyledOffsetContainer>
  );
};
Button.displayName = "Button";
